import { DraftTeam, DraftTeamCreationState } from '@Models';
import { tool_pairing_team, tool_pairing_team_dto } from '@Api';
import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import { TeamArmyMapper } from './TeamArmyMapper';
import { DrawMapper } from './DrawMapper';

@injectable()
export class DraftTeamMapper {
  @inject(TYPES.Mapper.TeamArmyMapper) private _teamArmyMapper!: TeamArmyMapper;
  @inject(TYPES.Mapper.DrawMapper) private _drawMapper!: DrawMapper;

  public map(item: tool_pairing_team): DraftTeam {
    return {
      id: item.id,
      leadId: item.lead_id,
      state: this.mapState(item.state),
      name: item.name,
      draw: item.draw != null ? this._drawMapper.map(item.draw) : null,
      teamArmies: item.team_armies.map((t) => this._teamArmyMapper.map(t)),
    } satisfies DraftTeam as DraftTeam;
  }

  public toDto(item: DraftTeam): tool_pairing_team_dto {
    return {
      name: item.name,
      team_armies_attributes: item.teamArmies.map((t) =>
        this._teamArmyMapper.toDto(t),
      ),
    };
  }

  public mapState(item: tool_pairing_team.state): DraftTeamCreationState {
    switch (item) {
      case tool_pairing_team.state.CREATED:
        return DraftTeamCreationState.created;
    }

    return DraftTeamCreationState.pending;
  }
}
